<script lang="ts">
  import { CenterImage } from '@centerhealth/fe/center-kit';
  import { createSource, ISrcSetData } from '@centerhealth/fe/images';

  const videoObjects: ISrcSetData[] = [
    {
      sourceUrl: '/assets/images/feature/hero-demo_compressed.webm',
    },
    {
      sourceUrl: '/assets/videos/features-hero.webm',
    },
  ];
</script>

<section class="my-9 overflow-x-clip">
  <div
    class="container relative grid grid-col-1 md:grid-cols-12 place-items-center gap-10 mx-auto py-4"
  >
    <div class="mt-7 flex flex-col gap-2 md:col-span-5 md:mt-0 xxl:col-start-2">
      <h2 class="text-center leading-tight md:text-left text-black z-10">
        🍝 Instantly track your carbs and other events
      </h2>
      <p class="xl:text-lg text-center md:text-left text-gray z-10">
        Counting carbs shouldn't be difficult. A quick search or barcode scan, and you're on your
        way.
      </p>
    </div>
    <div class="order-first md:order-last md:col-span-7 xxl:col-start-7">
      <CenterImage>
        <video playsinline autoplay muted loop>
          <source src={createSource(videoObjects[0].sourceUrl)} type="video/webm" />
          <source src={createSource(videoObjects[1].sourceUrl)} type="video/mp4" />
        </video>
      </CenterImage>
    </div>
  </div>
</section>

<style lang="postcss">
  video {
    @apply -z-10;
    transform: scale3d(1.8, 1.8, 1.8);
  }
</style>
